<template>
  <div class="alpha-mask">
    <div class="login-out-container">
      <div
        class="action-item"
        v-for="item in props.menu"
        :key="item.id"
        :_href="item.path"
        @click="handleClickItem(item)"
      >
        <span :class="item.icon"></span>
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router'
  import http from '@/http'
  import { inject, ref } from 'vue'
  import { eventBus } from '@common/utils/eventBus'
  defineOptions({
    name: 'LoginOut'
  })

  const props = defineProps({
    menu: {
      type: Array as any
    }
  })

  const router = useRouter()
  const $clearKeepCache = inject('clearKeepCache')

  const logout = async () => {
    await http.post('/aigc/api/auth/logout')
    window.location.href = '/'
  }

  const clearAllCatch = () => {
    $clearKeepCache && ($clearKeepCache as Function)()
  }

  const handleClickItem = (item: any) => {
    eventBus.trigger('closeTicketDrawer')
    eventBus.trigger('closeNotice')
    if (item.id === 'logout') {
      logout()
      return
    }
    if (item.path) {
      if (item.path.startsWith('http://') || item.path.startsWith('https://')) {
        // 全连接，使用链接方式跳转
        window.location.href = item.path
      } else {
        clearAllCatch()
        // 普通 path，使用 router 跳转
        router.push(item.path)
      }
    }
  }
</script>

<style scoped lang="stylus">
  @import './index.styl'
</style>
